"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Text_1 = require("../Text/Text");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var styled_components_1 = __importStar(require("styled-components"));
var Tab = function (_a) {
    var className = _a.className, disabled = _a.disabled, href = _a.href, label = _a.label, name = _a.name, onChange = _a.onChange, secondary = _a.secondary, selectedTabName = _a.selectedTabName, testid = _a.testid;
    // This is so that we can pass href's for seo but not have them actually route
    var onClick = React.useCallback(function (event) {
        if (typeof onChange === 'function') {
            onChange(event);
        }
        event.stopPropagation();
        event.preventDefault();
    }, [onChange]);
    // in the case that we dont have an href, we dont do anything
    if (!Boolean(href)) {
        // @ts-ignore
        onClick = onChange;
    }
    var selected = selectedTabName === name;
    return (React.createElement(StyledTab, { "$disabled": disabled, "$selected": selected, "aria-selected": selected, className: className, "data-testid": disabled ? 'disabled' : 'not-disabled' },
        React.createElement(StyledA, { "data-testid": testid, href: href, name: name, onClick: disabled ? undefined : onClick }, secondary ? (React.createElement(StyledPrimary, { "$selected": selected }, label)) : (React.createElement(StyledH5, { "$selected": selected, as: "h5" }, label)))));
};
exports.default = React.memo(Tab, react_fast_compare_1.default);
var StyledTab = styled_components_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: 24px;\n    display: flex;\n    ", "\n\n    @media (max-width: ", ") {\n        margin-right: 16px;\n    }\n\n    &:last-child {\n        margin-right: 0;\n    }\n"], ["\n    margin-right: 24px;\n    display: flex;\n    ", "\n\n    @media (max-width: ", ") {\n        margin-right: 16px;\n    }\n\n    &:last-child {\n        margin-right: 0;\n    }\n"])), function (props) {
    if (props.$selected) {
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                border-bottom: 4px solid ", ";\n            "], ["\n                border-bottom: 4px solid ", ";\n            "])), props.theme.colors.blue100);
    }
    if (props.$disabled) {
        return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                && > * {\n                    cursor: not-allowed;\n                }\n            "], ["\n                && > * {\n                    cursor: not-allowed;\n                }\n            "])));
    }
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.mobileWidth;
});
var StyledH5 = (0, styled_components_1.default)(Text_1.H5)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var $selected = _a.$selected, theme = _a.theme;
    return (!$selected ? theme.colors.grey200 : '');
});
var StyledPrimary = (0, styled_components_1.default)(Text_1.BodyPrimary)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var $selected = _a.$selected, theme = _a.theme;
    return (!$selected ? theme.colors.grey200 : '');
});
var StyledA = styled_components_1.default.a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-decoration: none;\n    cursor: pointer;\n    padding: 0;\n    border-bottom: 4px solid transparent;\n    vertical-align: center;\n"], ["\n    text-decoration: none;\n    cursor: pointer;\n    padding: 0;\n    border-bottom: 4px solid transparent;\n    vertical-align: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
